import React, { useEffect, useMemo, useState } from 'react';
import { Button, Dialog, IconButton, CircularProgress } from "@mui/material";
import CloseIcon from '@mui/icons-material/Close';
import { useSelector, useDispatch } from 'react-redux';
import { RootState } from 'src/redux/store';
import {
  setSelectedBusinessName,
  setSelectedLocationId,
  setSelectedAccountId
} from 'src/redux/localSeo';
import {
  setLocalSeoId,
  setLocalSeoBusinessId
} from 'src/common/config/FunctionHelperPartTwo';
import DropdownPopover from 'src/components/UI/DropdownPopover';
import { IGBPLocation } from '../../hooks/useSiteGBP1to1Maping';

interface EnableLocalSEOAgentDialogProps {
  GBPLocations: IGBPLocation[];
  open: boolean;
  onClose: () => void;
  onEnable: (selectedProfile?: any) => void;
  isLoading?: boolean;
  showProfileSelector?: boolean;
  profiles?: any[];
  selectedProfile?: any;
  onSelectProfile?: (profile: any) => void;
  isOptionDisabled?: (profile: any) => boolean;
  getOptionDisabledTooltip?: (profile: any) => string;
}

export default function EnableLocalSEOAgentDialog({
  GBPLocations,
  open,
  onClose,
  onEnable,
  isLoading = false,
  showProfileSelector = true,
  profiles: customProfiles,
  selectedProfile = null,
  onSelectProfile,
  isOptionDisabled,
  getOptionDisabledTooltip
}: EnableLocalSEOAgentDialogProps) {
  // const dispatch = useDispatch();

  // const reduxFilteredLocationsData: any = useSelector(
  //   (state: RootState) => state.localSeo.reduxFilteredLocationsData
  // ) ?? [];

  // const reduxLocationsData: any = useSelector(
  //   (state: RootState) => state.localSeo.reduxLocationsData
  // ) ?? [];

  // const reduxSelectedBusinessName: any = useSelector(
  //   (state: RootState) => state.localSeo.selectedBusinessName
  // ) ?? '';

  // const profiles = useMemo(() => {
  //   if (customProfiles && customProfiles.length > 0) {
  //     return customProfiles;
  //   }
  //   if (Array.isArray(reduxFilteredLocationsData) && reduxFilteredLocationsData.length > 0) {
  //     return reduxFilteredLocationsData;
  //   }
  //   if (Array.isArray(reduxLocationsData) && reduxLocationsData.length > 0) {
  //     return reduxLocationsData;
  //   }
  //   return [];
  // }, [customProfiles, reduxFilteredLocationsData, reduxLocationsData]);

  // const [selectedLoc, setSelectedLoc] = useState<any>(null);

  // useEffect(() => {
  //   if (open) {
  //     if (customSelectedProfile && (!isOptionDisabled || !isOptionDisabled(customSelectedProfile))) {
  //       setSelectedLoc(customSelectedProfile);
  //     } else if (reduxSelectedBusinessName && profiles.length > 0) {
  //       const matched = profiles.find(
  //         (loc: any) =>
  //           (loc?.title === reduxSelectedBusinessName || loc?.name === reduxSelectedBusinessName) &&
  //           (!isOptionDisabled || !isOptionDisabled(loc))
  //       );
  //       const firstAvailable = profiles.find((loc: any) => !isOptionDisabled || !isOptionDisabled(loc));
  //       setSelectedLoc(matched || firstAvailable || null);
  //     } else if (profiles.length > 0) {
  //       const firstAvailable = profiles.find((loc: any) => !isOptionDisabled || !isOptionDisabled(loc));
  //       setSelectedLoc(firstAvailable || null);
  //     } else {
  //       setSelectedLoc(null);
  //     }
  //   }
  // }, [open, customSelectedProfile, reduxSelectedBusinessName, profiles, isOptionDisabled]);

  const handleProfileChange = (profile: any) => {
    // setSelectedLoc(profile);
    if (onSelectProfile) {
      onSelectProfile(profile);
    }
  };

  const handleEnable = () => {
    if (selectedProfile) {
      // dispatch(setSelectedBusinessName(selectedLoc?.title));
      // dispatch(setSelectedLocationId(selectedLoc?.name));
      // dispatch(setSelectedAccountId(selectedLoc?.accountId));
      // setLocalSeoId(selectedLoc?.name);
      // setLocalSeoBusinessId(selectedLoc?.accountId);
      onEnable(selectedProfile);
    } else {
      onEnable();
    }
  };

  // const isSelectedDisabled = selectedLoc ? Boolean(isOptionDisabled && isOptionDisabled(selectedLoc)) : false;

  const isEnableDisabled =
    isLoading || (showProfileSelector && GBPLocations.length === 0) || !selectedProfile

  return (
    <Dialog open={open} onClose={() => !isLoading && onClose()} disableScrollLock>
      <div className="p-6 min-w-[600px] max-w-[600px] relative">
        <p className="text-primary font-semibold text-xl mb-3">
          Confirm Agent Activation
        </p>

        <p className={`font-medium text-[15px] text-[#475467] ${showProfileSelector ? 'mb-5' : 'my-9'}`}>
          Enabling the agent will allow it to audit your Google Business Profile and provide optimization recommendations.
        </p>

        {showProfileSelector && (
          <div className="mb-8">
            <label className="block text-sm font-medium text-[#344054] mb-2">
              Select Google Business Profile
            </label>
            {GBPLocations && GBPLocations.length > 0 ? (
              <DropdownPopover
                startIcon="/static/images/icons/local-seo/google-home.svg"
                selectedValue={selectedProfile}
                options={GBPLocations}
                onSelect={handleProfileChange}
                isArrayOfObject={true}
                labelKey="title"
                idKey="name"
                placeholder="Select Business"
                enableSearch={GBPLocations.length > 5}
                searchPlaceholder="Search profiles..."
                disabled={isLoading}
                isOptionDisabled={isOptionDisabled}
                getOptionDisabledTooltip={getOptionDisabledTooltip}
                styles={{
                  filterBoxSx: {
                    width: '100%',
                    borderColor: '#D0D5DD',
                    borderRadius: '8px',
                    minHeight: '44px'
                  }
                }}
              />
            ) : (
              <div className="p-3 rounded-lg bg-[#F9FAFB] border border-[#EAECF0] text-sm text-[#667085]">
                No connected Google Business Profile found.
              </div>
            )}
          </div>
        )}

        <div className="flex gap-2">
          <Button
            className="h-[40px] flex-1"
            variant="outlined"
            onClick={() => onClose()}
            disabled={isLoading}
          >
            Cancel
          </Button>
          <Button
            className="h-[40px] flex-1"
            variant="contained"
            onClick={handleEnable}
            disabled={isEnableDisabled}
          >
            {isLoading ? (
              <CircularProgress size={20} sx={{ color: '#FFFFFF' }} />
            ) : (
              "Enable"
            )}
          </Button>
        </div>

        <div aria-label="dialog-close-btn" className="absolute top-0 right-0">
          <IconButton
            aria-label="close"
            className="hover:rounded-lg"
            sx={{
              position: 'absolute',
              top: 12,
              right: 12,
              zIndex: 2,
              height: '40px',
              padding: '8px',
              paddingRight: '8px'
            }}
            onClick={() => onClose()}
            disabled={isLoading}
          >
            <CloseIcon />
          </IconButton>
        </div>
      </div>
    </Dialog>
  );
}
